import axios from 'axios';
import { API_URL, ID_TOKEN, ID_CADASTRO_FASE } from '../config/constants';

const decodeToken = async token => {
    const res = await axios.get(`${API_URL}auth/decode`, { headers: { Authorization: token } });
    const decoded = res.data;
    return decoded;
}

const getToken = () => {
    return localStorage.getItem(ID_TOKEN);
}

const getUser = async id => {
    //const token = getToken();
    const usuario = await axios.get(`${API_URL}usuarios/${id}?populate_grupo=code`);

    return usuario.data;
}

const setToken = (token) => {
    return localStorage.setItem(ID_TOKEN, token);
}

const unsetToken = () => {
    localStorage.removeItem(ID_CADASTRO_FASE);
    return localStorage.removeItem(ID_TOKEN);
}

const isLogged = () => {
    return getToken();
}

const login = async (data) => {
    const res = await axios.post(`${API_URL}/auth`, data);
    if (!res.data.erro) {
        setToken(res.data.token);
    }

    return res.data;
}

const getConfigAws = async () => {
    const res = await axios.get(`${API_URL}auth/get-aws-config`, { headers: { Authorization: getToken() } });
    const result = res.data;
    return result;
}

export {
    decodeToken,
    isLogged,
    getToken,
    setToken,
    unsetToken,
    login,
    getUser,
    getConfigAws
};